import { BaseFetch } from "../main-model"
export default class ReportAccumulatedPayModel extends BaseFetch {
    getReportStudentOfficeBy = (data) =>
    this.authFetch({
      url: "report-accumulated-pay/getReportAccumulatedPayBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportStudentOfficeYear = (data) =>
    this.authFetch({
      url: "report-accumulated-pay/getReportAccumulatedPayYear",
      method: "POST",
      body: JSON.stringify(data),
    })
}
